import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { StringUtils } from '../StringUtils';

export class Validacoes {
  static ValidaCpf(controle: AbstractControl) {
    const cpfcnpj:string = controle.value.replace(/[^0-9]/g, '');
    
    let soma: number = 0;
    let resto: number;
    let valido: boolean;
    let isCpf: boolean;

    let mult1 = [6,7,8,9,2,3,4,5,6,7,8,9];
    let mult2 = [5,6,7,8,9,2,3,4,5,6,7,8,9];

    const regex = new RegExp('[0-9]{11}');

    if ( cpfcnpj.length == 11 ){
        isCpf = true;
    }else{
        isCpf = false;
    }

    if (
        cpfcnpj == '00000000000' ||
        cpfcnpj == '11111111111' ||
        cpfcnpj == '22222222222' ||
        cpfcnpj == '33333333333' ||
        cpfcnpj == '44444444444' ||
        cpfcnpj == '55555555555' ||
        cpfcnpj == '66666666666' ||
        cpfcnpj == '77777777777' ||
        cpfcnpj == '88888888888' ||
        cpfcnpj == '99999999999' ||
      !regex.test(cpfcnpj)
    )
      valido = false;
    else {
      
      if ( isCpf ){
        for (let i = 1; i <= 9; i++)
        soma = soma + parseInt(cpfcnpj.substring(i - 1, i)) * (11 - i);
        resto = (soma * 10) % 11;

        if (resto == 10 || resto == 11) resto = 0;
        if (resto != parseInt(cpfcnpj.substring(9, 10))) {
          valido = false;
        }else{
          valido = true;
        }

        soma = 0;
        for (let i = 1; i <= 10; i++)
            soma = soma + parseInt(cpfcnpj.substring(i - 1, i)) * (12 - i);
        resto = (soma * 10) % 11;

        if (resto == 10 || resto == 11) resto = 0;
        if (resto != parseInt(cpfcnpj.substring(10, 11))){
          valido = false;
        } else{
          valido = true;
        }
        
      }else{
          let dig1 = 0;
          let dig2 = 0;
          // fazendo multiplicador 1
        for (let i = 1; i <= 12; i++){
            soma = soma + parseInt(cpfcnpj.substring(i - 1, i)) * mult1[i-1];
            dig1 = soma % 11 == 10? 0 : soma % 11;
        }

        soma = 0;
        for (let i = 1; i <= 13; i++){
            
            soma = soma + parseInt(cpfcnpj.substring(i - 1, i)) * mult2[i-1];
            dig2 = soma % 11 == 10? 0 : soma % 11;
        }

        
        if ( dig1 == parseInt(cpfcnpj.substring(12,13)) && dig2 == parseInt(cpfcnpj.substring(13,14))  ){
            valido = true;
        }else{
            valido = false;
        }

      }
      
    }

        if (valido){
            return null;  
        } 
        
     return { cpfInvalido: true };
  }

  static MaiorQue18Anos(controle: AbstractControl) {
    const nascimento = controle.value;
    const [ano, mes, dia] = nascimento.split('-');
    const hoje = new Date();
    const dataNascimento = new Date(ano, mes, dia, 0, 0, 0);
    const tempoParaTeste = 1000 * 60 * 60 * 24 * 365 * 18; //18 anos em mili segundos...

    if (hoje.getTime() - dataNascimento.getTime() >= tempoParaTeste)
      return null;

    return { menorDeIdade: true };
  }

  static SamePassword(oldPass:string):ValidatorFn {
 
    return (controle: AbstractControl): ValidationErrors | null => {
      if ( controle == null || controle.get('password') == null ){
        return null;
      }
      
      let senha = controle.get('password').value;
      if ( btoa( senha ) == oldPass ){
        controle.get('confirmacao').setErrors({ samePassword: true });
        return { 'samePassword': true }
      }

      return null;
    };
  }
  
  static SenhasCombinam(controle: AbstractControl) {
    
    let senha = controle.get('password').value;
    let confirmarSenha = controle.get('confirmacao').value;

    if (senha === confirmarSenha) return null;

    controle.get('confirmacao').setErrors({ senhasNaoCoincidem: true });
  }


  static patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        // if control is empty return no error
        return null;
      }
  
      // test the value of the control against the regexp supplied
      const valid = regex.test(control.value);
  
      // if true, return no error (no error), else return error passed in the second parameter
      return valid ? null : error;
    };
  }
}